import React, { Component } from 'react';
import { Box, Button, Card, Grid, Typography } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import CardPage from '../../../../commonModules/layouts/CardPage';
import { GroupRadio, SingleRadio } from '../../../../commonModules/MUI/RadioAndCheckbox';
import { toast } from 'react-toastify';
import axios from 'axios';
import { ArrowBackRounded, ArrowDownwardRounded, ArrowForwardRounded, ArrowUpwardRounded } from '@material-ui/icons';
import PopUp from '../../../../commonModules/interface/PopUp';
import PreviewLoc from './PreviewLoc';
import PreviewLocForm from './PreviewLocForm';

const scale = 50; // 1 mètre = 50 pixels dans l'aperçu

class FormLoc extends Component {

    state = {
        local_name: "",
        local_shop_id: "",
        local_orientation: "h",
        local_longueur: 20,
        local_largeur: 10,
        local_hauteur: 0,
        local_nb_zones: 0,
        zones: []
        // local_nb_sections: 0,
        // local_nb_levels: 2,
    };

    addZone = () => {
        const { zones } = this.state;
    
        let newZones = [...zones];
        newZones.push({
            nb_sections: 0,
            sections: [] // Initialize as an empty array
        });
    
        this.setState({
            local_nb_zones: newZones.length,
            zones: newZones
        });
    }
    
    removeZone = (index) => {
        const { zones } = this.state;
    
        if (index >= 0 && index < zones.length) {
            let newZones = [...zones];
            newZones.splice(index, 1);
    
            this.setState({
                local_nb_zones: newZones.length,
                zones: newZones
            });
        }
    }
    
    addSection = (zoneIndex) => {
        const { zones } = this.state;
    
        console.log('===============in ADD SECTION=====================');
        console.log(zoneIndex, zones[zoneIndex]);
        console.log('====================================');
        if (zoneIndex >= 0 && zoneIndex < zones.length) {
            let newZones = [...zones];
            newZones[zoneIndex].sections.push({
                nb_levels: 1
            });
            newZones[zoneIndex].nb_sections = newZones[zoneIndex].sections.length;
    
            this.setState({
                zones: newZones
            });
        }
    }
    removeSection = (zoneIndex, sectionIndex) => {
        const { zones } = this.state;
    
        if (zoneIndex >= 0 && zoneIndex < zones.length) {
            const updatedZones = [...zones];
            const zone = updatedZones[zoneIndex];
    
            if (sectionIndex >= 0 && sectionIndex < zone.sections.length) {
                zone.sections.splice(sectionIndex, 1);
                zone.nb_sections = zone.sections.length;
    
                this.setState({
                    zones: updatedZones
                });
            }
        }
    }
    addLevel = (zoneIndex, sectionIndex) => {
        const { zones } = this.state;
        const updatedZones = [...zones];

        if (zoneIndex >= 0 && zoneIndex < updatedZones.length) {
            const zone = updatedZones[zoneIndex];

            if (sectionIndex >= 0 && sectionIndex < zone.sections.length) {
                const section = zone.sections[sectionIndex];
                section.nb_levels++; // Incrémentez le nombre de niveaux

                this.setState({ zones: updatedZones });
            }
        }
    }

    removeLevel = (zoneIndex, sectionIndex) => {
        const { zones } = this.state;
        const updatedZones = [...zones];

        if (zoneIndex >= 0 && zoneIndex < updatedZones.length) {
            const zone = updatedZones[zoneIndex];

            if (sectionIndex >= 0 && sectionIndex < zone.sections.length) {
                const section = zone.sections[sectionIndex];

                if (section.nb_levels > 1) {
                    section.nb_levels--; // Décrémentez le nombre de niveaux
                    this.setState({ zones: updatedZones });
                }
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleChangeF = (e) => {
        const { name, value } = e.target;
        const regexFloat = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        if(value === "" || regexFloat.test(value)){// update value only if its a int || float
            this.setState({
                [name]: value
            })
        }        
    }

    handleSubmit = async () => {
        let data = { 
            local_name: this.state.local_name,
            local_shop_id: this.props.shop.id,
            local_orientation: this.state.local_orientation, // or vertical 
            local_longueur: parseFloat(this.state.local_longueur),
            local_largeur: parseFloat(this.state.local_largeur),
            local_hauteur: parseFloat(this.state.local_hauteur),
            // local_nb_zones: parseInt(this.state.local_nb_zones),
            // local_nb_sections: parseInt(this.state.local_nb_sections),
            // local_nb_levels: parseInt(this.state.local_nb_levels) || 1    
            zones: this.state.zones
        }
        
        let res = await axios.post("/stocks/addData", {
            page: "local/new",
            data: data
        }) 
        if(res.data.error){
            console.log("ERROR", res.data.error);
            this.setState({
                sending: false,
            })
            let errorMessage = "Une erreur est survenue";
            if (typeof res.data.error === 'string') {
                errorMessage = res.data.error;
            } else if (res.data.error && typeof res.data.error === 'object') {
                errorMessage = res.data.error.message || res.data.error.error || JSON.stringify(res.data.error);
            }
            toast.error(errorMessage)
        } else{
            console.log("fetched");
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Opération enregistrée avec succès")
            // this.props.filterList(undefined, undefined)
            this.props.handleClose()
        }   
    }
    render() {
        const { local_longueur, local_largeur, local_name, local_orientation, local_hauteur, local_nb_zones} = this.state;

        console.log('===============STATE=====================');
        console.log(this.state);
        console.log('====================================');

        // TODO Ajout custom avec mesures exact % et placement des zones 
        return (
            <CardPage title="Création Local">
                <Box>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={4}>
                            <Box p={2}>
                                <Typography gutterBottom variant="button" color="secondary">
                                    <b>Dimensions</b>
                                </Typography>
                            </Box>
                            <InputText
                                title="Nom du Local"
                                name="local_name"
                                value={this.state.local_name}
                                onChange={this.handleChange}
                            />
                            <Grid container item xs={12}>
                                <Grid item xs={4} sm={12} md={4}>
                                    <InputText
                                        title="Longueur (m)"
                                        name="local_longueur"
                                        value={this.state.local_longueur}
                                        onChange={this.handleChangeF}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={12} md={4}>
                                    <InputText
                                        title="Largeur (m)"
                                        name="local_largeur"
                                        value={this.state.local_largeur}
                                        onChange={this.handleChangeF}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={12} md={4}>
                                    <InputText
                                        title="Hauteur (m)"
                                        name="local_hauteur"
                                        value={this.state.local_hauteur}
                                        onChange={this.handleChangeF}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={12} sm={4}>
                            {/* <Box p={2}>
                                <Typography gutterBottom variant="button" color="secondary">
                                    <b>Disposition</b>
                                </Typography>
                            </Box>
                            
                            <InputText
                                title="Nombre de zones"
                                name="local_nb_zones"
                                value={this.state.local_nb_zones}
                                type="number"
                                onChange={this.handleChangeF}
                            /> */}

                            <Box p={1}>
                                <GroupRadio label="Orientation" onChange={(e) => this.setState({local_orientation: e.target.value})} color="primary">
                                    <SingleRadio value="h" checked={local_orientation === "h"}label="Horizontale" />
                                    <SingleRadio value="v" checked={local_orientation === "v"}label="Verticale" />
                                </GroupRadio>

                            </Box>
                        </Grid>
                        <Grid xs={12} sm={4}>
                            {/* <Box p={2}>
                                <Typography gutterBottom variant="button" color="secondary">
                                    <b>Répartition</b>
                                </Typography>
                            </Box> */}
                            
                            {/* <InputText
                                title="Nombre de sections par Zones"
                                name="local_nb_sections"
                                value={this.state.local_nb_sections}
                                type="number"
                                onChange={this.handleChangeF}
                                />
                            <InputText
                                title="Nombre d'étages"
                                name="local_nb_levels"
                                type="number"
                                value={this.state.local_nb_levels}
                                onChange={this.handleChangeF}
                            /> */}
                        </Grid>
                        <Grid item xs={12}>
                            <Button 
                                variant="contained" 
                                color="primary"
                                onClick={this.handleSubmit}
                            >
                                Créer
                            </Button>
                        </Grid>
                        <Grid item xs={12} >
                            <PreviewLocForm 
                                form
                                addSection={this.addSection}
                                removeSection={this.removeSection}
                                addZone={this.addZone}
                                removeZone={this.removeZone}
                                addLevel={this.addLevel}
                                removeLevel={this.removeLevel}
                                {...this.state}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </CardPage>
        );
    }
}

export default FormLoc;